import styled from "@emotion/styled";

import { COLOR_STALE_GRAY } from "../../constants/styles";

export const InputLabel = styled.label`
  text-transform: uppercase;
  font-size: 12px;
  color: ${COLOR_STALE_GRAY};
  font-weight: 700;
`;
